import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import ReactHtmlParser from "react-html-parser";
import { scroller } from "react-scroll";

import * as S from "./styles";

import Button from "../../components/button";
import Modal from "../../components/modal";

import { api } from "../../services/api";
import { onDataLayer } from "../../services/use-data-layer";
import { submitLGPD } from "../../services/lgpd";

const FormApplication = () => {
	const KEY_STORAGE = 'ESTACIO_FORTNITE';
	const KEY_STORAGE_LOG = '@ESTACIO_FORTNITE';

	const [openModal, setOpenModal] = useState(false);
	const [modalMessage, setModalMessage] = useState(null);

	const [phone, setPhone] = useState("");
	const [cpf, setCpf] = useState("");
	const [nomeResponsavel, setNomeResponsavel] = useState("");
	const [cpfResponsavel, setCpfResponsavel] = useState("");

	const [cpfResIsValid, setCpfResIsValid] = useState(false);
	const [cpfIsValid, setCpfIsValid] = useState(false);
	const [checkSmaller, setCheckSmaller] = useState(false);
	const [isVisible, setIsVisible] = useState(false);
	const [regulation, setRegulation] = useState(false);

	const [alreadyRegistered, setAlreadyRegistered] = useState(false); // ONSUBMIT - Quando fizer cadastro
	const [login, setLogin] = useState({ error: false, logged: false }); // ONSUBMIT2 - Quando fizer login
	const [gameCode, setGameCode] = useState(false); // ONSUBMIT3 - Quando enviar o código da sorte

	const [isRegister, setIsRegister] = useState(false); // Quando for feito o cadastro o form é oculto
	const [isCode, setIsCode] = useState(false); // Quando for inserir o código do jogo
	const [showBtns, setShowBtns] = useState(false); // Quando for feito o cadastro o form é oculto e os botões são mostrados
	const [luckyNumber, setLuckyNumber] = useState(false); // Quando clicar para ver números da sorte cadastrados

	const {
		register,
		reset,
		getValues,
		formState: { isValid }
	} = useForm({ mode: 'onChange' });

	const {
		register: register2,
		reset: reset2,
		setValue: setValue2,
		getValues: getValues2,
		formState: { isValid: isValid2 }
	} = useForm({ mode: 'onChange' });

	const {
		register: register3,
		reset: reset3,
		getValues: getValues3,
		formState: { isValid: isValid3 }
	} = useForm({ mode: 'onChange' });

	const onSubmit = async (event) => {
		event.preventDefault();

		const [aceito, regulamento] = getValues(['Aceito', 'Regulamento']);

		aceito ? setIsVisible(false) : setIsVisible(true);
		regulamento ? setRegulation(false) : setRegulation(true);

		if (isValid && !cpfIsValid && !cpfResIsValid) {
			const [name, email, phone, cpf] = getValues(['Nome_Completo', 'Email', 'Telefone', 'CPF']);

			if (checkSmaller) {
				const response = await api.post("/participante", { 
					nome: name, 
					email: email, 
					telefone: onSpecialCharacters(phone), 
					cpf: onSpecialCharacters(cpf), 
					maior18: false, 
					nomeResponsavel: nomeResponsavel, 
					cpfResponsavel: onSpecialCharacters(cpfResponsavel) 
				});

				if (response.data.status !== 'OK') {
					setModalMessage`
						<p>Ops! Você já está cadastrado.</p>
					`;
					onOpenModal();

					// Push DataLayer error
					onDataLayer(response.data.status, response.status, 'erro-menor-de-18', response.data.mensagem);

					setAlreadyRegistered(true);
				} else {
					setModalMessage`
						<p>Boa! Você já está cadastrado. Agora é só aproveitar os  conteúdos e se preparar para o ENEM.</p>
					`;
					onOpenModal();

					localStorage.setItem(KEY_STORAGE, JSON.stringify(email));
					localStorage.removeItem(KEY_STORAGE_LOG);

					// Enviar dados LGPD
					submitLGPD(onSpecialCharacters(cpf), name, onSpecialCharacters(phone), email, onSpecialCharacters(cpfResponsavel), nomeResponsavel);

					// Push DataLayer sucesso
					onDataLayer(response.data.status, response.status, 'sucesso-menor-de-18', response.data.mensagem);

					setAlreadyRegistered(false);
				}
			} else {
				const response = await api.post("/participante", { 
					nome: name, 
					email: email, 
					telefone: onSpecialCharacters(phone), 
					cpf: onSpecialCharacters(cpf), 
					maior18: true, nomeResponsavel: null, cpfResponsavel: null });

				if (response.data.status !== 'OK') {
					setModalMessage`
						<p>Ops! Você já está cadastrado.</p>
					`;
					onOpenModal();

					// Push DataLayer error
					onDataLayer(response.data.status, response.status, 'erro-maior-de-18', response.data.mensagem);

					setAlreadyRegistered(true);
				} else {
					setModalMessage`
						<p>Boa! Você já está cadastrado. Agora é só aproveitar os  conteúdos e se preparar para o ENEM.</p>
					`;
					onOpenModal();

					localStorage.setItem(KEY_STORAGE, JSON.stringify(email));
					localStorage.removeItem(KEY_STORAGE_LOG);

					// Enviar dados LGPD
					submitLGPD(onSpecialCharacters(cpf), name, onSpecialCharacters(phone), email, null, null);

					// Push DataLayer sucesso
					onDataLayer(response.data.status, response.status, 'sucesso-maior-de-18', response.data.mensagem);

					setAlreadyRegistered(false);
				}
			}

			return window.scrollTo({ top: 0, behavior: 'smooth' });
		}
	};

	const onSubmit2 = async (event) => {
		event.preventDefault();

		if (isValid2) {
			const [email2] = getValues2(['Email2']);

			const response = await api.get(`/participante?email=${email2}`);

			if (response.data.status !== 'OK') {
				setModalMessage`
					<p>Ops, parece que você se esqueceu do cadastro. Vamos lá, é rapidinho!</p>
				`;
				onOpenModal();

				// Push DataLayer erro
				onDataLayer(response.data.status, response.status, 'erro-login', response.data.mensagem);

				setLogin({ error: true, logged: false }); // Se der erro o modal deverá ser fechado e não limpar o form
			} else {
				setModalMessage`
					<p>Você já está logado. Agora é só aproveitar os conteúdos!</p>
				`;
				onOpenModal();

				// Push DataLayer sucesso
				onDataLayer(response.data.status, response.status, 'sucesso-login', response.data.mensagem);

				localStorage.setItem(KEY_STORAGE, JSON.stringify(email2));
				localStorage.setItem(KEY_STORAGE_LOG, JSON.stringify(true));

				setLogin({ error: false, logged: true });
				onSetStatesForms();
			}
		} else {
			setModalMessage`
				<p>Ops, email inválido ou parece que você se esqueceu do cadastro. Vamos lá, é rapidinho!</p>
			`;
			onOpenModal();
		}
	};

	const onSubmit3 = async (event) => {
		event.preventDefault();

		const userData = localStorage.getItem(KEY_STORAGE) || '{}';
		const userDataObj = JSON.parse(userData);

		if (isValid3 && userDataObj) {

			const [codigo] = getValues3(['Codigo']);

			const response = await api.post('/participante', {
				email: userDataObj,
				codigo: codigo
			});
			
			if (response.data.status !== "OK") {
				setModalMessage(`<p>${response.data.mensagem}</p>`);
				onOpenModal();

				// Push DataLayer erro
				onDataLayer(response.data.status, response.status, 'erro-salvar-codigo-do-jogo', response.data.mensagem);
				
				setGameCode(false);
			} else {
				setModalMessage(`<p>${response.data.mensagem}</p>`);
				onOpenModal();

				// Push DataLayer sucesso
				onDataLayer(response.data.status, response.status, 'sucesso-salvar-codigo-do-jogo', response.data.mensagem);

				setGameCode(true);
			}
		}
	};

	const onCloseModal = () => {
		if (alreadyRegistered) {
			setOpenModal(false);
		} else if (login.error) {
			setOpenModal(false);
		} else if (!login.error) {
			setOpenModal(false);
			setIsRegister(true);			
			setShowBtns(true);
			setValue2("Email2", "");
			reset2();

			scroller.scrollTo("toRegister", { smooth: true });
		} else {
			setOpenModal(false);
			reset();
			reset2();
			reset3();

			setPhone("");
			setCpf("");
			setNomeResponsavel("");
			setCpfResponsavel("");
			setCheckSmaller(false);
			setCpfIsValid(false);
			setCpfResIsValid(false);
			setIsVisible(false);
			setIsRegister(true);
			setShowBtns(true);
		}
	};

	const onCloseModal2 = () => {
		if (gameCode) {
			setOpenModal(false);
			setIsRegister(false);
			setShowBtns(false);
			setCheckSmaller(false);
			setCpfIsValid(false);
			setCpfResIsValid(false);
			reset();
			reset2();
			reset3();

			setPhone("");
			setCpf("");
			setNomeResponsavel("");
			setCpfResponsavel("");
		} else {
			setOpenModal(false);
		}

		return setGameCode(false);
	};

	const onSetStatesForms = () => {
		reset();
		reset2();
		reset3();
		setPhone("");
		setCpf("");
		setNomeResponsavel("");
		setCpfResponsavel("");
		setValue2("Email2", "");
	};

	const onOpenModal = () => {
		setOpenModal(true);
	};

	const onMaskInputs = (type, value) => {
		if (type) {
			let phone = value.replace(/\D/g, "");
			phone = phone.replace(/^0/, "");
			if (phone.length > 10) {
				phone = phone.replace(/^(\d\d)(\d{5})(\d{4}).*/, "($1) $2-$3");
			} else if (phone.length > 5) {
				phone = phone.replace(/^(\d\d)(\d{4})(\d{0,4}).*/, "($1) $2-$3");
			} else if (phone.length > 2) {
				phone = phone.replace(/^(\d\d)(\d{0,5})/, "($1) $2");
			} else {
				phone = phone.replace(/^(\d*)/, "($1");
			}
			return phone;
		} else {
			const checkCPF = onValidatorCpf(value);

			// Verificação usuário maior de 18
			if (checkCPF != null && !checkSmaller) {
				setCpfIsValid(true);
			} else {
				setCpfIsValid(false);
			}

			// Verificação usuário menor de 18
			if (checkCPF != null && checkSmaller) {
				setCpfResIsValid(true);
			} else {
				setCpfResIsValid(false);
			}

			return value.replace(/\D/g, "")
				.replace(/(\d{3})(\d)/, "$1.$2")
				.replace(/(\d{3})(\d)/, "$1.$2")
				.replace(/(\d{3})(\d{1,2})/, "$1-$2")
				.replace(/(-\d{2})\d+?$/, "$1");
		}
	};

	const onSpecialCharacters = (value) => {
		if (value) {
			return value.replace(/([\u0300-\u036f]|[^0-9a-zA-Z])/g, "");
		} else {
			return null;
		}
	};

	const onValidatorCpf = (value) => {
		const cpf = String(value).replace(/\D+/gi, '');
		const invalid = { 'invalid': true };

		let numbers = null;
		let digits = null;
		let sum = null;
		let result = null;
		let equalDigits = 1;

		for (let i = 0; i < cpf.length - 1; i++) {
			if (cpf.charAt(i) !== cpf.charAt(i + 1)) {
				equalDigits = 0;
				break;
			}
		}

		if (!equalDigits) {
			numbers = cpf.substring(0, 9);
			digits = cpf.substring(9);
			sum = 0;

			for (let i = 10; i > 1; i--) {
				sum += numbers.charAt(10 - i) * i;
			}

			result = sum % 11 < 2 ? 0 : 11 - sum % 11;
			if (String(result) !== digits.charAt(0)) {
				return invalid;
			}

			numbers = cpf.substring(0, 10);
			sum = 0;
			for (let i = 11; i > 1; i--) {
				sum += numbers.charAt(11 - i) * i;
			}

			result = sum % 11 < 2 ? 0 : 11 - sum % 11;
			if (String(result) !== digits.charAt(1)) {
				return invalid;
			}

			return null;

		} else {
			return invalid;
		}
	};

	const onShowButtons = (event) => {
		if (event === 1) {
			setIsCode(true);
			setShowBtns(false);
		} else {
			setIsCode(false);
			setShowBtns(false);
			setIsRegister(false);
			setCheckSmaller(false);

			reset();
			reset2();
			reset3();

			setPhone("");
			setCpf("");
			setNomeResponsavel("");
			setCpfResponsavel("");

			scroller.scrollTo("toMission", { smooth: true, offset: 60 });
		}
	};

	const onConvertObject = (object) => {
		const array = object.map(function(obj) {
			return Object.keys(obj).map(function(key) {
				return obj[key];
			});
		});

		return array;
	};

	useEffect(() => { 
		if (luckyNumber) {
			const userData = localStorage.getItem(KEY_STORAGE) || '{}';
			const userEmail2 = JSON.parse(userData);
			const MESSAGE_1 = 'Seu número da sorte é';
		
			if (userEmail2) {
				api.get(`/participante?email=${userEmail2}`)
					.then((response) => {
						const object = [];

						object.push(response.data.numeros);

						const array = onConvertObject(object);

						if (array[0][2]) {
							setModalMessage(`
								<p>
									${array[0][2] && MESSAGE_1}: ${array[0][2]}.
								</p>
							`);
							onOpenModal();
						} else {
							setModalMessage(`
								<p>Você ainda não tem um número da sorte, para conseguir, pegue o código no jogo e o recupere.</p>
							`);
							onOpenModal();
						}
					});

				setLuckyNumber(false);
			}
		}
	 }, [luckyNumber]);

	return (
		<S.FormApplication id="toRegisterMobile" className="border">

			<div className="form">
				{!isRegister && <h2 className="headline">Venha para o ENEMVERSO e concorra a bolsas de 100% NA GRADUAÇÃO</h2>}
				{isRegister && <h2 className="headline">Você já recuperou seu código da semana no Fortnite?</h2>}

				{!isRegister && <form onSubmit={(e) => onSubmit(e)} method="post">
					<div className="input-group" id="container_COLUMN1">
						<input type="text" required className="form-control" placeholder="Nome Completo" name="Nome_Completo" label="Nome_Completo" {...register("Nome_Completo", { required: true })} data-element="input_nome-completo" />
						<p className="msg-error">Error</p>
					</div>
					<div className="input-group" id="container_COLUMN1">
						<input type="email" required className="form-control" name="Email" label="Email" placeholder="Email" {...register("Email", { required: true })} data-element="input_email" />
						<p className="msg-error">Error</p>
					</div>
					<div className="input-group-grid">
						<div className="input-group" id="container_COLUMN1">
							<input type="tel" required className="form-control" name="Telefone" label="Telefone" placeholder="Telefone"	{...register("Telefone", { required: true })} onChange={(e) => setPhone(onMaskInputs(true, e.target.value))} value={phone} data-element="input_telefone" />
							<p className="msg-error">Error</p>
						</div>
						<div className="input-group" id="container_COLUMN1">
							<input required className="form-control" name="CPF" label="CPF" placeholder="CPF" {...register("CPF", { required: true })} onChange={(e) => setCpf(onMaskInputs(false, e.target.value))} value={cpf} data-element="input_cpf" />
						</div>
					</div>
					<div className="content-error">
						{cpf && cpfIsValid && <p className="msg-error">CPF Inválido</p>}
					</div>

					<div className="input-group">
						<div className="custom-check">
							<input type="checkbox" id="Menor" name="Menor_18" label="Menor_18" {...register("Menor_18")} onChange={() => setCheckSmaller(!checkSmaller)} value={checkSmaller} checked={checkSmaller} data-element="check_menor_18" />
							<label htmlFor="Menor">Declaro ser menor de 18 anos.</label>
						</div>
					</div>
		
					{checkSmaller && <>
						<div className="input-group" id="container_COLUMN1">
							<input type="text" required={checkSmaller} className="form-control" placeholder="Nome Completo do Responsável" name="Nome_Completo_Responsavel" label="Nome_Completo_Responsavel" value={nomeResponsavel} onChange={(e) => setNomeResponsavel(e.target.value)} data-element="input_nome-completo-responsavel" />
							<p className="msg-error">Error</p>
						</div>
						<div className="input-group" id="container_COLUMN1">
							<input required className="form-control" name="CPF_Responsavel" label="CPF_Responsavel" placeholder="CPF do Responsável" value={cpfResponsavel} onChange={(e) => setCpfResponsavel(onMaskInputs(false, e.target.value))} data-element="input_cpf-responsavel" />
						</div>
						<div className="content-error content-error2">
							{cpfResponsavel && cpfResIsValid && <p className="msg-error">CPF do responsável inválido</p>}
						</div>
					</>}
					<div className="input-group">
						<div className="custom-check">
							<input type="checkbox" id="Accept" name="Aceito" label="Aceito" {...register("Aceito", { required: true })} data-element="check_aceito" />
							<label htmlFor="Accept">Declaro que sou MAIOR DE 16 anos e concordo com a Política de privacidade Estácio e demais instituições do grupo bem como o tratamento dos meus dados para a finalidade prevista no meu formulário. Ao continuar você aceita que Estácio e demais instituições do grupo entrem em contato. <a href='https://privacidade.estacio.br/home' data-element='link_política-de-privacidade' target='_blank' rel="noreferrer">Política de Privacidade.</a></label>
						</div>
					</div>
					{isVisible && <p className="msg-error content-error3">Concorde com a política de privacidade</p>}
					<div className="input-group">
						<div className="custom-check">
							<input type="checkbox" id="Regulamento" name="Regulamento" label="Regulamento" {...register("Regulamento", { required: true })} data-element="check_regulamento" />
							<label htmlFor="Regulamento">Li e aceito o <a href='https://portal.estacioprd.net/documents/20124/1460081/regulamento-completo.pdf' data-element='link_regulamento' target='_blank' rel="noreferrer">regulamento</a> desta promoção</label>
						</div>
					</div>
					{regulation && <p className="msg-error content-error3">Aceite o regulamento</p>}
					<div className="input-action">
						<Button
							label="ACESSAR CONTEÚDO"
							fontSize="14"
							height="48"
							width="204"
							padding="16px 2px"
							action={() => null}
							dataElement="button_acessar-conteudo"
							weight={900}
							hoverColor="#18B7EF"
						/>
					</div>
				</form>}
				{isRegister &&
					<div className="register">
						
						{showBtns && <div className="buttons">
							<Button
								label="SIM"
								fontSize="14"
								height="48"
								width="124"
								padding="0 10px"
								action={() => onShowButtons(1)}
								dataElement="button_registro_sim"
								hoverColor="#18B7EF"
							/>
							<Button
								label="NÃO"
								fontSize="14"
								height="48"
								width="124"
								padding="0 10px"
								action={() => onShowButtons(2)}
								dataElement="button_registro_nao"
								hoverColor="#18B7EF"
							/>
						</div>}

						{!showBtns && isCode && <form onSubmit={(e) => onSubmit3(e)} method="post">
							<div className="input-group">
								<input type="text" required className="form-control" placeholder="Insira o código" name="Codigo" label="Codigo" {...register3("Codigo", { required: true })} data-element="input_nome-completo" />
								<p className="msg-error">Error</p>
							</div>
							<div className="btn-is-code">
								<Button
									label="VALIDAR CÓDIGO"
									fontSize="14"
									height="48"
									width="124"
									padding="0 10px"
									action={() => null}
									dataElement="button_validar-codigo"
									hoverColor="#18B7EF"
								/>
								<div className="space"></div>
								<Button
									label="VOLTAR"
									fontSize="14"
									height="48"
									width="124"
									padding="0 10px"
									action={() => setShowBtns(true)}
									dataElement="button_voltar"
									hoverColor="#18B7EF"
								/>
							</div>
						</form>}

				</div>}
			</div>

			<div className="form" id="alreadyRegistered">
				<h2 className="headline">Já se cadastrou?</h2>
				<div>
					<form className="input-group-grid" onSubmit={(e) => onSubmit2(e)} method="post">
						<div className="input-group">
							<input type="text" required className="form-control" placeholder="E-mail" name="Email2" label="Email2" {...register2("Email2", { required: true })} data-element="input_ja-se-cadastrou" />
							<p className="msg-error">Error</p>
						</div>
						<Button
							label="VALIDE SEU E-MAIL"
							fontSize="14"
							height="48"
							width="186"
							padding="15 11px"
							action={() => null}
							weight={900}
							dataElement="button_valide-seu-email"
							hoverColor="#18B7EF"
						/>
					</form>
				</div>
			</div>

			{login.logged && <a href="#!" onClick={() => setLuckyNumber(true)} className="link-relembrar-numero" data-element="link_relembrar-numero-da-sorte">Já pegou seu número da sorte? Clique aqui para relembrá-lo.</a>}

			<Modal isOpen={openModal} onClose={gameCode ? onCloseModal2 : onCloseModal}>
				{ReactHtmlParser(modalMessage)}
			</Modal>

		</S.FormApplication>
	);
};

export default FormApplication;
